module.exports = __webpack_public_path__ + "assets/images/img_waiting.3889d06.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons/img_waiting.svg
// module id = 474
// module chunks = 2